import React, { useState, useEffect, useReducer } from 'react'
import { Navbar, Nav, Spinner } from 'react-bootstrap'
import { Route, Switch, useLocation } from 'react-router-dom'
import Axios from 'axios'
import endpoints from '../js/endpoints'
import pagePath from '../pagePath'
import TripInfo from '../routes/TripInfo'
import Test from '../routes/Test'
import MapInfo from '../routes/MapInfo'
import DriverLocation from '../routes/DriverLocation'
import Logo from '../assets/image/logo.png'

export default function Main() {

  let routes = [
    {
      path: pagePath.tripInfoPath,
      component: TripInfo,
    },
    {
      path: pagePath.tripInfo,
      component: TripInfo,
    },

    {
      path: pagePath.map,
      component: MapInfo,
    },
    {
      path: pagePath.driver_locationPath,
      component: DriverLocation,
    },
    {
      path: "test",
      component: Test,
    },

  ]


  return (
    <div className="container-fluid m-0 p-0 h-auto">
      <NavBar />
      <Switch>
        {routes.map((route, i) => (
          <Route
            key={i}
            path={route.path}
            exact
            component={route.component}

          />
        ))}
      </Switch>
    </div>
  )
}

function NavBar(props) {
  return (

    <Navbar bg="dark" variant="dark" className=" flex-md-nowrap p-2">
      <Navbar.Brand>
        {props.title}
      </Navbar.Brand>
      <Nav className="mr-auto">
        <img src={Logo} width="30px" height="30px" />
      </Nav>
    </Navbar>

  )
}
